import * as React from 'react';
import {Group, Title, Button, Avatar} from '@mantine/core';
import { FaPlus } from 'react-icons/fa';

interface SimpleHeaderProps{
    title : string;
    right?: any;
    Icon?: any;
    button?: { title: string; onClick: any, [key: string]: any };
    buttons?: { title: string; onClick: any, [key: string]: any }[];
}

export default function SimpleHeader(props : SimpleHeaderProps){
    let {Icon, title, button, right, buttons} = props;
    buttons = buttons || (button ? [button] : [])
    return <Group position="apart" m="md">
        <Group style={{flex: 1}}>
            {Icon && <Avatar color="orange"><Icon size="1.5rem" /></Avatar>}
            <Title order={3} color="orange">{title}</Title>
        </Group>
        <>
            {buttons.map(button => <Button
                variant='outline'
                {...button}
                >{button.title}</Button>)}
        </>
        {right}
    </Group>
}